// eslint-disable-next-line import/prefer-default-export
export const getPageRecords = (
  records: unknown[],
  pageNumber: number,
  recordsPerPage: number
): unknown[] =>
  records.slice((pageNumber - 1) * recordsPerPage, pageNumber * recordsPerPage);
